import { useAppSelector } from '@/redux/hooks';
import { watchOptionsList } from '@/redux/slices/options.slice';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useMemo, useState } from 'react';
import { BannerSliderDetailsTabs } from './banner-slider-details.tabs';
export const BannerSliderTabs = () => {
  const platformList = useAppSelector(watchOptionsList);
  const [key, setKey] = useState<string>(platformList[0]?.id.toString());
  const onChange = (key: string) => {
    setKey(key);
  };
  const itemTabs: TabsProps['items'] = useMemo(
    () =>
      platformList.map((platform) => ({
        key: platform?.id.toString(),
        label: platform.name,
        children: <BannerSliderDetailsTabs id={key} />
      })),
    [platformList, key]
  );

  return (
    <div>
      <Tabs items={itemTabs} onChange={onChange} />
    </div>
  );
};
